(function ($) {
    $(document).ready(function () {
      // Slick Track Attribute
        $('.snowSlides .slick-track').attr("aria-label", "homepage-slider");
        $('.hero .slick-track').attr("aria-label", "hero-slide");
        $('.product__thumb-item').attr("tabindex", - 1);
        $('.product__thumb-item').removeAttr("aria-hidden");
        $('.product__photos .slick-track').attr("aria-label", "product-photos");
		$('.slick-dots li').attr('role','tab');
      	$('.slick-dots li').removeAttr("aria-hidden");
      	$('.slick-dots li').removeAttr("aria-controls");
      	$('.slick-dots li').attr("role", "tab");
		$("#Slideshow-announcement-bar").attr("data-role", "none");
      /*$(".slideshow__slide a").attr("aria-hidden", true);*/
      $(".slideshow__slide.slick-active").attr("tabindex", 0); 

      

    });
})(jQuery);
